<template>
  <div class="user-menu">
    <el-menu default-active="1-1" @select="menuSelectHandle">
      <menu-item :menus="menus" />
    </el-menu>
  </div>
</template>

<script setup>
  import { defineEmits } from 'vue'
  import MenuItem from './MenuItem.vue'
  import { menuTypeEnum } from '@/enums/menuEnum'

  const emits = defineEmits(['select'])

  const menus = [
    {
      title: '订单列表',
      index: '1',
      menuType: menuTypeEnum.orderList,
      children: [
        {
          menuType: menuTypeEnum.orderList,
          title: '全部',
          index: '1-1',
          type: ''
        },
        {
          menuType: menuTypeEnum.orderList,
          title: '待付款',
          index: '1-2',
          type: 'wait_pay'
        },
        {
          menuType: menuTypeEnum.orderList,
          title: '待收货',
          index: '1-3',
          type: 'wait_receive'
        },
        {
          menuType: menuTypeEnum.orderList,
          title: '已完成',
          index: '1-4',
          type: 'complete'
        },
        {
          menuType: menuTypeEnum.orderList,
          title: '待评价',
          index: '1-5',
          type: 'wait_comment'
        },
        {
          menuType: menuTypeEnum.orderList,
          title: '退款售后',
          index: '1-6',
          type: 'refunded'
        },
        {
          menuType: menuTypeEnum.orderList,
          title: '已取消',
          index: '1-7',
          type: 'cancel'
        }
      ]
    }
  ]

  const menuSelectHandle = key => {
    const selectedMenu = getSelectedNode(key, menus)
    selectedMenu && emits('select', selectedMenu)
  }

  const getSelectedNode = (key, nodes) => {
    for (const node of nodes) {
      if (node.index === key) return node
      if (node.children && node.children.length) {
        const result = getSelectedNode(key, node.children)
        if (result) return result
      }
    }
  }
</script>

<style lang="scss" scoped></style>
